'use strict';

//const e = React.createElement;

function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }

class CustomerProfile extends React.Component {
  constructor(props) {
    super(props);
    _defineProperty(this, "handleSubmit", e => {
      //e.preventDefault();
      this.setState({
        loading: true
      });
      const {
        customer
      } = this.state;
      const customerID = this.props.customerID;

      function isValidEmail(email) {
          return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
      }
  
      if (!isValidEmail(customer.email)) {
          alert("請填寫正確電郵。"); // Fixed incorrect semicolon
          this.setState({
            loading: false
          });
          return;
      }
      
      fetch("https://iheartzshop-api-2.herokuapp.com/v1/customer/public/" + customerID, {
        method: "PUT",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          customerID: customer.customerID,
          email: customer.email,
          id_no: customer.id_no,
          birthday: customer.birthday,
          facebook_link: customer.facebook_link
        })
      }).then(res => res.json()).then(result => {
        console.log("result", result);
        //setTimeout(() => window.location.reload(), 700);
      },
      // Note: it's important to handle errors here
      // instead of a catch() block so that we don't swallow
      // exceptions from actual bugs in components.
      error => {
        console.log(error);
      }).finally(() => setTimeout(() => window.location.reload(), 700));
    });
    _defineProperty(this, "handleFormChange", e => {
      this.setState({
        customer: {
          ...this.state.customer,
          [e.target.name]: e.target.value
        }
      });
    });
    _defineProperty(this, "rednerDisplayForm", customer => {
      return /*#__PURE__*/React.createElement("div", {
        className: ""
      }, /*#__PURE__*/React.createElement("table", {
        style: {
          width: "100%"
        }
      }, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", {
        width: "30%",
        style: {
          padding: "10px 0px"
        }
      }, " ", "\u96FB\u90F5 :", " "), /*#__PURE__*/React.createElement("td", {
        width: "70%",
        style: {
          padding: "10px 0px"
        }
      }, " ", customer.email, " ")), /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", {
        width: "30%",
        style: {
          padding: "10px 0px"
        }
      }, " ", "\u5BA2\u6236\u7DE8\u865F :", " "), /*#__PURE__*/React.createElement("td", {
        width: "70%",
        style: {
          padding: "10px 0px"
        }
      }, " ", customer.member_no, " ")), /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", {
        width: "30%",
        style: {
          padding: "10px 0px"
        }
      }, " ", "\u5927\u540D\u53CA\u6703\u54E1 :", " "), /*#__PURE__*/React.createElement("td", {
        width: "70%",
        style: {
          padding: "10px 0px"
        }
      }, " ", customer.first_name, " ", customer.last_name, " ")), /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", {
        width: "30%",
        style: {
          padding: "10px 0px"
        }
      }, " ", "\u8EAB\u4EFD\u8B49\u865F\u78BC* :", " "), /*#__PURE__*/React.createElement("td", {
        width: "70%",
        style: {
          padding: "10px 0px"
        }
      }, " ", customer.id_no)), /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", {
        width: "30%",
        style: {
          padding: "10px 0px"
        }
      }, " ", "\u751F\u65E5 :", " "), /*#__PURE__*/React.createElement("td", {
        width: "70%",
        style: {
          padding: "10px 0px"
        }
      }, " ", customer.birthday, " ")), /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", {
        width: "30%",
        style: {
          padding: "10px 0px"
        }
      }, " ", "Facekbook \u9023\u7D50 :", " "), /*#__PURE__*/React.createElement("td", {
        width: "70%",
        style: {
          padding: "10px 0px"
        }
      }, " ", customer.facebook_link, " "))), /*#__PURE__*/React.createElement("p", {
        style: {
          marginTop: "50px"
        }
      }, "* \u53F0\u7063\u5831\u95DC\u9700\u5BE6\u540D\u8A8D\u8B49\uFF0C\u8ACB\u4E00\u5B9A\u8981\u7559\u4E0B\u6B63\u78BA\u7684EZway\u6536\u4EF6\u8CC7\u6599\uFF0C\u5546\u54C1\u5747\u662F\u7F8E\u570B\u76F4\u5BC4\uFF0C\u82E5\u6709\u586B\u5BEB\u624D\u4E0D\u6703\u5EF6\u8AA4\u6E05\u95DC *\u4E2D\u570B\u8CB7\u5BB6\u8ACB\u4E00\u5B9A\u8981\u7559\u4E0B\u8EAB\u4EFD\u8B49\u865F", " "));
    });
    _defineProperty(this, "renderEditForm", customer => /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
      className: "ui tiny form"
    }, /*#__PURE__*/React.createElement("div", {
      className: "field"
    }, /*#__PURE__*/React.createElement("label", null, "\u96FB\u90F5"), /*#__PURE__*/React.createElement("input", {
      type: "text",
      name: "email",
      value: customer.email,
      onChange: this.handleFormChange
    })), /*#__PURE__*/React.createElement("div", {
      className: "field"
    }, /*#__PURE__*/React.createElement("label", null, "\u5BA2\u6236\u7DE8\u865F"), /*#__PURE__*/React.createElement("input", {
      type: "text",
      value: customer.member_no,
      readOnly: true
    })), /*#__PURE__*/React.createElement("div", {
      className: "field"
    }, /*#__PURE__*/React.createElement("label", null, "\u6703\u54E1\u540D\u5B57"), /*#__PURE__*/React.createElement("input", {
      type: "text",
      value: customer.first_name + " " + customer.last_name,
      readOnly: true
    })), /*#__PURE__*/React.createElement("div", {
      className: "field"
    }, /*#__PURE__*/React.createElement("label", null, "\u8EAB\u4EFD\u8B49\u865F\u78BC"), /*#__PURE__*/React.createElement("input", {
      type: "text",
      name: "id_no",
      placeholder: "",
      value: customer.id_no,
      onChange: this.handleFormChange
    })), /*#__PURE__*/React.createElement("div", {
      className: "field"
    }, /*#__PURE__*/React.createElement("label", null, "\u751F\u65E5"), /*#__PURE__*/React.createElement("input", {
      type: "date",
      name: "birthday",
      value: customer.birthday,
      onChange: this.handleFormChange
    })), /*#__PURE__*/React.createElement("div", {
      className: "field"
    }, /*#__PURE__*/React.createElement("label", null, "Facekbook \u9023\u7D50"), /*#__PURE__*/React.createElement("input", {
      type: "text",
      name: "facebook_link",
      value: customer.facebook_link,
      onChange: this.handleFormChange
    })), /*#__PURE__*/React.createElement("div", {
      style: {
        display: "flex",
        gap: "8px"
      }
    }, /*#__PURE__*/React.createElement("button", {
      style: {
        width: "100%",
        backgroundColor: "grey"
      },
      onClick: () => this.setState({
        edit: false
      })
    }, "\u53D6\u6D88"), /*#__PURE__*/React.createElement("button", {
      style: {
        width: "100%"
      },
      onClick: () => this.handleSubmit()
    }, "\u5132\u5B58")))));
    this.state = {
      customer: {},
      edit: false,
      loading: false
    };
  }
  componentDidMount() {
    this.setState({
      loading: true
    });
    const customerID = this.props.customerID;
    fetch("https://iheartzshop-api-2.herokuapp.com/v1/customer/public/" + customerID).then(res => res.json()).then(result => {
      console.log("result", result);
      this.setState({
        customer: {
          customerID: result.data.customerID,
          email: result.data.email,
          first_name: result.data.first_name,
          last_name: result.data.last_name,
          member_no: result.data.member_no,
          id_no: result.data.id_no,
          birthday: result.data.birthday,
          facebook_link: result.data.facebook_link
        }
      });
    },
    // Note: it's important to handle errors here
    // instead of a catch() block so that we don't swallow
    // exceptions from actual bugs in components.
    error => {
      console.log(error);
    }).finally(() => setTimeout(() => this.setState({
      loading: false
    })), 700);
  }
  render() {
    const {
      loading,
      customer,
      edit
    } = this.state;
    return /*#__PURE__*/React.createElement("div", {
      class: "card profile_form"
    }, /*#__PURE__*/React.createElement("div", {
      class: "card__section card__section--flex card__section--tight"
    }, /*#__PURE__*/React.createElement("h1", {
      class: "card__title heading h1"
    }, "\u6211\u7684\u8CC7\u6599"), /*#__PURE__*/React.createElement("button", {
      onClick: () => this.setState({
        edit: true
      })
    }, "\u66F4\u6539")), /*#__PURE__*/React.createElement("div", {
      style: {
        padding: "0em 2em"
      }
    }, !loading ? edit ? this.renderEditForm(customer) : this.rednerDisplayForm(customer) : /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("i", {
      className: "spinner loading icon"
    }))));
  }
}

// Find all DOM containers, and render Like buttons into them.
document.querySelectorAll('.customer_profile_container')
  .forEach(domContainer => {
    // Read the comment ID from a data-* attribute.
    const customerID = parseInt(domContainer.dataset.customerid, 10);
    const root = ReactDOM.createRoot(domContainer);
    root.render(
      e(CustomerProfile, { customerID: customerID })
    );
  });